export default __webpack_public_path__ + "static/media/Inconsolata-Bold.3b64d902.woff2";